import angular from 'angular'

import moveRun from './move.run'
import moveRoutes from './move.routes'
import moveCtrl from './move.controller'

const name = 'routingManeuverMove'

angular.module(name, [

])
  .controller('moveCtrl', moveCtrl)
  .run(moveRun)
  .config(moveRoutes)

export default name



// WEBPACK FOOTER //
// ./public/javascript/sygem/routing/maneuver/move/move.module.js